import { Button } from '@zapier/marketing-ui';

interface ActionButtonProps {
  isDomainCaptureBlocked: boolean;
  isAutoJoin: boolean;
  onClickGoToHomepage: () => void;
  onClickJoinTeam: () => void;
}

export function ActionButton({
  isAutoJoin,
  isDomainCaptureBlocked,
  onClickGoToHomepage,
  onClickJoinTeam,
}: ActionButtonProps) {
  if (isDomainCaptureBlocked) {
    return (
      <Button variant="brand" size="small" onClick={onClickGoToHomepage}>
        Go to homepage
      </Button>
    );
  }

  if (isAutoJoin) {
    return (
      <Button variant="brand" size="small" onClick={onClickJoinTeam}>
        Join your team
      </Button>
    );
  }

  return (
    <Button variant="brand" size="small" onClick={onClickGoToHomepage}>
      Go to homepage
    </Button>
  );
}
